import FormStep from "../../services/models/formModels/MultiStepForm/formStep.model";
import CustomCheckBoxInputProps from "../../services/models/customCheckBoxInput.model";
import CustomRadioInputProps from "../../services/models/customRadioInput.model";
import CustomTextInputProps from "../../services/models/customTextInputProps.mode";

function isPathTouched(touched: Record<string, unknown>, path: string): boolean {
  const parts = path.split(".");
  let current: unknown = touched;

  for (const part of parts) {
    if (current == null || typeof current !== "object") {
      return false;
    }
    current = (current as Record<string, unknown>)[part];
  }

  return Boolean(current);
}

function getFieldName(field: FormStep["fields"][number]): string {
  return (
    (field as CustomTextInputProps).labelInfo?.inputId ??
    (field as CustomRadioInputProps | CustomCheckBoxInputProps).name ??
    ""
  );
}

export function isStepSectionTouched(
  step: FormStep,
  touched: Record<string, unknown>
): boolean {
  if (step.touchedFieldPaths?.length) {
    return step.touchedFieldPaths.some((path) => isPathTouched(touched, path));
  }

  return step.fields.some((field) => {
    const fieldName = getFieldName(field);
    if (!fieldName) return false;
    return isPathTouched(touched, fieldName);
  });
}

export default isStepSectionTouched;
